import { corsImport } from '@weapp/utils';
import { ShrinkData } from './page-view/grid-layout/layout/types';
import { ComLayoutScope } from './page-view/types';

type Args = {
  /** 布局拉伸改变后的回调 */
  resize: [fromToggle?: boolean, scope?: ComLayoutScope];
  /** 页面数据加载完成后 */
  pageLoad: [any, any];
  /** 系统详情modal关闭回调 */
  onrefresh: [needRefreshAgain: boolean];
  /** 页面reload */
  reload: [pageId: string];
  /** 组件load */
  compLoad: [comId: string, comInstance?: any, context?: any];
  /** 组件mount前 */
  compBeforeMount: [comId: string, comInstance?: any];
  /** ecode Loaded */
  ecodeLoad: [];
  /** 组件resize */
  'com.resize': [comId?: string];
  /** 弹窗确认事件 */
  dialogConfirm: [];
  /** 重新计算内容区域的宽度以及右侧推出的宽度 */
  'contentView.resize': [];
  /** 组件加载完成 */
  lazyrender: [comId: string];
  /** 表单组件change回调 */
  'field.change': [];
  'com.layoutchange': [];
  /** 边栏收缩回调 */
  'layoutsider.shrink': [ShrinkData: ShrinkData];
  /** 触发组件配置按钮 —— 组件刷新 */
  'operation.btn': [comid?: string, e?: any, condition?: any];
  pageInit: [any];
  /** 清除组件刷新标识 */
  clearRefresh: [];
  'updatePage.coms': [pageId: string, data: any];
  /** 触发左边栏收缩 */
  'toggleShrink.leftSidebar': [isExpand: boolean];
  /** 触发右边栏收缩 */
  'toggleShrink.rightSidebar': [isExpand: boolean];
  /** 触发中间栏收缩 */
  'toggleShrink.main': [isExpand: boolean];
  /** 触发 自定义页面组件 是否弹出事件 */
  'showDesignPanel.visible': [];
  /** 触发 首屏加载完成 */
  'com.firstScreenLoaded': [];
  /** 卡片布局信息改变事件 */
  'change.cardLayout': [comId: string, layout: any];
};

export type EventHandlerKeys = keyof Args;
const asyncDesigner = async () => {
  if (window.weappDesigner) {
    return Promise.resolve(window.weappDesigner);
  }

  const weappDesigner = await corsImport('@weapp/designer');

  return weappDesigner;
};

export default class Event {
  // 兼容comEvent中的写法
  // TODO: comEvent被替换后需要移除
  _event: any;

  private asyncEvent = asyncDesigner().then(({ EventEmitter }) => {
    const events = new EventEmitter();

    this._event = events._event;

    return events;
  });

  on = <T extends EventHandlerKeys>(eventType: T, ...args: any) => {
    this.asyncEvent.then((event) => event.on(eventType, ...args));

    return this;
  };

  ready = <T extends EventHandlerKeys>(eventType: T, ...args: any) => {
    this.asyncEvent.then((event) => event.ready(eventType, ...args));

    return this;
  };

  off = (eventType: EventHandlerKeys, ...args: any) => {
    this.asyncEvent.then((event) => event.off(eventType, ...args));

    return this;
  };

  emit = async <T extends EventHandlerKeys>(eventType: T, ...args: Args[T]) => {
    const result = await this.asyncEvent.then((event) => event.emit(eventType, ...args));

    return result;
  };

  once = <T extends EventHandlerKeys>(eventType: T, ...args: any) => {
    this.asyncEvent.then((event) => event.once(eventType, ...args));
  };

  /**
   * TODO 移除
   * 切换页面清除当前页面filter缓存，放到event里面便于跨模块组件调用
   */
  clearFilterCache = () => {
    this.asyncEvent.then((event) => event.clearFilterCache());
  };

  initPlugins = <T extends EventHandlerKeys>(name: T | any[], type: any, opts?: any) => {
    this.asyncEvent.then((event) => event.initPlugins(name, type, opts));
  };

  registerPlugins = (p: Record<string, any>) => {
    this.asyncEvent.then((event) => event.registerPlugins(p));
  };

  // eslint-disable-next-line max-len
  getPlugin = <T extends EventHandlerKeys>(eventType: T) => this.asyncEvent.then((event) => event.getPlugin(eventType));
}
